import React, { useEffect, useMemo } from "react";
import { Accordion, Nav, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { hasKeys, isAdminRole } from "../shared/utils";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Sidebar = ({
  isOpen,
  setIsSidebarOpen,
  toggleSidebar,
  location,
  params,
  onGenerateReset,
}) => {
  const isAdmin = useMemo(() => isAdminRole(), []);

  const navigate = useNavigate();
  const rotateStyle = {
    transform: !isOpen ? "rotate(180deg)" : "none",
    transition: "transform 0.3s ease-in-out", // Optional: Adding transition for a smooth effect
  };
  const imageSize = isOpen ? 110 : 52; // Default size: 50px
  const imageStyle = {
    borderRadius: "50%",
    width: imageSize,
    height: imageSize,
    objectFit: "cover", // Ensure the image covers the entire container
  };
  useEffect(() => {
    let formData_1 = localStorage.getItem("tokenData");
    axios
      .post(
        "https://" +
          process.env.REACT_APP_HOST +
          "/webservice/rest/server.php?moodlewsrestformat=json&wsfunction=core_webservice_get_site_info",
        formData_1,
      )
      .then((userdata) => {
        if (!userdata.data.userid) {
          localStorage.setItem("login", false);
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const sideBarActive = useMemo(() => {
    if (hasKeys(params) && hasKeys(params.action)) {
      return params.action;
    } else {
      return "";
    }
  }, [location, params]);
  console.log("isOpen", isOpen);
  return (
    <div className={`sidebar p-2 ${isOpen ? "sidebar-open" : "close"}`}>
      <div className="sidebar-content accordion-box">
        <Accordion
          className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          defaultActiveKey="1"
        >
          <Accordion.Item eventKey="1">
            <Accordion.Header className="align-items-center">
              <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                <img src={"/images/scribe.svg"} alt="video" />
              </div>
              {isOpen && <div>Scribe AI Content</div>}
            </Accordion.Header>
            <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
              <Accordion.Body>
                {isOpen && (
                  <Nav className="flex-column accordion-menu-wrapper">
                    <Nav.Link
                      active={sideBarActive == "scribe-content-generate"}
                      as={Link}
                      to="/home/scribe-content-generate"
                      onClick={() => {
                        if (location.pathname.includes("/home/scribe-content-generate")) {
                          onGenerateReset?.();
                        }
                      }}
                    >
                      Generate
                    </Nav.Link>
                    <Nav.Link
                      active={sideBarActive == "scribe-contents"}
                      as={Link}
                      to="/home/scribe-contents"
                    >
                      Generated content
                    </Nav.Link>
                    {isAdmin && (
                      <Nav.Link
                        active={sideBarActive == "scribe-settings"}
                        as={Link}
                        to="/home/scribe-settings"
                      >
                        Settings
                      </Nav.Link>
                    )}
                  </Nav>
                )}
              </Accordion.Body>
            </div>
          </Accordion.Item>
        </Accordion>

        {/* {isAdmin && <Accordion className={`accordion-box ${isOpen ? 'maximized' : 'minimized'} mt-2`}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="align-items-center">
                            <div className={`${isOpen ? 'me-2' : 'me-0'} ${isOpen ? '' : 'mx-auto'}`}>
                                <img src={"/images/ping_video.svg"} alt='video' />
                            </div>
                            {isOpen && <div>Pinging Video</div>}
                        </Accordion.Header>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <Accordion.Body>
                                {isOpen && <Nav className="flex-column accordion-menu-wrapper">
                                    <Nav.Link active={sideBarActive == 'pinging-video-good'} as={Link} to="/home/pinging-video-good">Good</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-video-bad'} as={Link} to="/home/pinging-video-bad">Bad</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-video-all'} as={Link} to="/home/pinging-video-all">All</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-video-downloaded'} as={Link} to="/home/pinging-video-downloaded">Downloaded</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-video-not-downloaded'} as={Link} to="/home/pinging-video-not-downloaded">Not Downloaded</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-video-backup'} as={Link} to="/home/pinging-video-backup">Replaced bakc up video</Nav.Link>
                                </Nav>}
                            </Accordion.Body>
                        </div>
                    </Accordion.Item>
                </Accordion>}

                {isAdmin && <Accordion className={`accordion-box ${isOpen ? 'maximized' : 'minimized'} mt-2`}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="align-items-center">
                            <div className={`${isOpen ? 'me-2' : 'me-0'} ${isOpen ? '' : 'mx-auto'}`}>
                                <img src={"/images/ping-web.svg"} alt='video' />
                            </div>
                            {isOpen && <div>Pinging Web</div>}
                        </Accordion.Header>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <Accordion.Body>
                                {isOpen && <Nav className="flex-column accordion-menu-wrapper">
                                    <Nav.Link active={sideBarActive == 'pinging-web-all'} as={Link} to="/home/pinging-web-all">All</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-web-good'} as={Link} to="/home/pinging-web-good">Good</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'pinging-web-bad'} as={Link} to="/home/pinging-web-bad">Bad</Nav.Link>
                                </Nav>}
                            </Accordion.Body>
                        </div>
                    </Accordion.Item>
                </Accordion>}

                {isAdmin && <Accordion className={`accordion-box ${isOpen ? 'maximized' : 'minimized'} mt-2`}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="align-items-center">
                            <div className={`${isOpen ? 'me-2' : 'me-0'} ${isOpen ? '' : 'mx-auto'}`}>
                                <img src={"/images/ping-ass-vid.svg"} alt='video' />
                            </div>
                            {isOpen && <div>Assignment Pinging Video</div>}
                        </Accordion.Header>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <Accordion.Body>
                                {isOpen && <Nav className="flex-column accordion-menu-wrapper">
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-video-all'} as={Link} to="/home/assignment-pinging-video-all">All</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-video-good'} as={Link} to="/home/assignment-pinging-video-good">Good</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-video-bad'} as={Link} to="/home/assignment-pinging-video-bad">Bad</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-video-downloaded'} as={Link} to="/home/assignment-pinging-video-downloaded">Downloaded</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-video-not-dowloaded'} as={Link} to="/home/assignment-pinging-video-not-dowloaded">Not Dowloaded</Nav.Link>
                                </Nav>}
                            </Accordion.Body>
                        </div>
                    </Accordion.Item>
                </Accordion>}



                {isAdmin && <Accordion className={`accordion-box ${isOpen ? 'maximized' : 'minimized'} mt-2`}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="align-items-center">
                            <div className={`${isOpen ? 'me-2' : 'me-0'} ${isOpen ? '' : 'mx-auto'}`}>
                                <img src={"/images/ping-ass-web.svg"} alt='video' />
                            </div>
                            {isOpen && <div>Assignment Pinging Web</div>}
                        </Accordion.Header>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <Accordion.Body>
                                {isOpen && <Nav className="flex-column accordion-menu-wrapper">
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-web-all'} as={Link} to="/home/assignment-pinging-web-all">All</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-web-good'} as={Link} to="/home/assignment-pinging-web-good">Good</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-pinging-web-bad'} as={Link} to="/home/assignment-pinging-web-bad">Bad</Nav.Link>
                                </Nav>}
                            </Accordion.Body>
                        </div>
                    </Accordion.Item>
                </Accordion>}

                {isAdmin && <Accordion className={`accordion-box ${isOpen ? 'maximized' : 'minimized'} mt-2`}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="align-items-center">
                            <div className={`${isOpen ? 'me-2' : 'me-0'} ${isOpen ? '' : 'mx-auto'}`}>
                                <img src={"/images/ass-contents.svg"} alt='video' />
                            </div>
                            {isOpen && <div>Assignment Contents</div>}
                        </Accordion.Header>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <Accordion.Body>
                                {isOpen && <Nav className="flex-column accordion-menu-wrapper">
                                    <Nav.Link active={sideBarActive == 'assignment-content-all'} as={Link} to="/home/assignment-content-all">All</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-content-video'} as={Link} to="/home/assignment-content-video">Video</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'assignment-content-web'} as={Link} to="/home/assignment-content-web">Web</Nav.Link>
                                </Nav>}
                            </Accordion.Body>
                        </div>
                    </Accordion.Item>
                </Accordion>}

                {isAdmin && <Accordion className={`accordion-box ${isOpen ? 'maximized' : 'minimized'} mt-2`}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="align-items-center">
                            <div className={`${isOpen ? 'me-2' : 'me-0'} ${isOpen ? '' : 'mx-auto'}`}>
                                <img src={"/images/course-contents.svg"} alt='video' />
                            </div>
                            {isOpen && <div>Course Contents</div>}
                        </Accordion.Header>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <Accordion.Body>
                                {isOpen && <Nav className="flex-column accordion-menu-wrapper">
                                    <Nav.Link active={sideBarActive == 'course-content-all'} as={Link} to="/home/course-content-all">All</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'course-contents-video'} as={Link} to="/home/course-contents-video">Video</Nav.Link>
                                    <Nav.Link active={sideBarActive == 'course-contents-web'} as={Link} to="/home/course-contents-web">Web</Nav.Link>
                                </Nav>}
                            </Accordion.Body>
                        </div>
                    </Accordion.Item>
                </Accordion>} */}
        <div className="sidebar-bottum">
          <div className="dot-image">
            {sideBarActive.includes("scribe") && (
              <Image src={"/images/scribe-dog.png"} alt="User Profile" style={imageStyle} />
            )}
          </div>
          <div className="panel-trigger">
            <Button variant="link" className="p-0" onClick={toggleSidebar}>
              <img
                src={"/images/left_panel_open.svg"}
                style={rotateStyle}
                className="img-fluid"
                alt="panel"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
